<div *ngFor="let item of filteredAttributes" class="wordbreak">
	<!-- --> <ng-container *ngIf="item.isFieldSet; else simpleField;">
		<div *ngIf="showHeader">
			<h2>{{item.label | hisUi}}</h2>
		</div>
		<!-- zeige seine children -->
		<res-dynamic-attribute-items-view [dynamicAttributeList]= "item.children"
			[staticFieldset] ="item.label"
			[position]="item.position">
		</res-dynamic-attribute-items-view>
    </ng-container>
	
    <ng-template #simpleField>	 
	     <div class="layoutBlock">
	          		<div class="columnDetailLabel detailPresentationListLabel"><span>{{item.label | hisUi}}</span></div>
	            	<div class="columnDetailContent detailPresentationListContent"><span>{{item.value}}</span></div>

	     </div>		
     </ng-template>
</div>